export const MAX_NUM_IMAGES = 15;
export const NO_FOCUS = "NO_FOCUS";
export const TITLE = "TITLE";
export const AREAS = "AREAS";
export const SIDEBAR = "SIDEBAR";
export const COVER = "COVER";
export const COURSE = "COURSE";
export const SOFTWARES = "SOFTWARES";
export const URL = "URL";
export const CLIENT = "CLIENT";
export const CLIENT_URL = "CLIENT_URL";
export const AGENCY = "AGENCY";
export const AGENCY_URL = "AGENCY_URL";
export const MORE_CONTENT = "MORE_CONTENT";
export const CONTENT_ITEMS_MENU = "CONTENT_ITEMS_MENU";
export const MAX_IMAGE_CAPTION_LENGTH = 125;
